<template>
  <div class="about">
    <h1>404 Page not Found</h1>
  </div>
</template>

<script>
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'about',
  components: {
    // HelloWorld
  },
  mounted: function(){
    let title = 'ページが見つかりませんでした'
    let description = 'ページが見つかりませんでした。お手数をおかけしますが、トップページから再度お探しください。'
    this.setHeader(title, description, true)
  }
}
</script>
